import { render, staticRenderFns } from "./ed-course-create-multimedia-object.component.vue?vue&type=template&id=fe3d6ac2&scoped=true&"
import script from "./ed-course-create-multimedia-object.component.ts?vue&type=script&lang=ts&"
export * from "./ed-course-create-multimedia-object.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-course-create-multimedia-object.component.scss?vue&type=style&index=0&id=fe3d6ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3d6ac2",
  null
  
)

export default component.exports